import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromCharts from "../reducers/chart.reducer";

export const getChartState = createFeatureSelector<fromCharts.ChartState>(fromCharts.FEATURE_KEY);

export const getChartEntities = createSelector(getChartState, fromCharts.getChartEntities);

export const getChartsLoaded = createSelector(getChartState, fromCharts.getChartsLoaded);

export const getCharts = createSelector(getChartEntities, (entities) => {
  return Object.keys(entities).map((id) => entities[id]);
});

export const getChartsError = createSelector(getChartState, (state) => state.error);
